import __var_0__ from '@stdlib/assert/is-plain-object';
import __var_1__ from '@stdlib/assert/has-own-property';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isPlainObject = __var_0__;
var hasOwnProp = __var_1__;


// MAIN //

/**
* Validates function options.
*
* @private
* @param {Object} opts - destination object
* @param {Options} options - function options
* @param {*} [options.invalid] - return value when an input iterator yields a non-numeric value
* @returns {(Error|null)} null or an error object
*
* @example
* var opts = {};
* var options = {
*     'invalid': NaN
* };
* var err = validate( opts, options );
* if ( err ) {
*     throw err;
* }
*/
function validate( opts, options ) {
	if ( !isPlainObject( options ) ) {
		return new TypeError( 'invalid argument. Options argument must be an object. Value: `' + options + '`.' );
	}
	if ( hasOwnProp( options, 'invalid' ) ) {
		opts.invalid = options.invalid;
	}
	return null;
}


// EXPORTS //
export default validate;
